import React, { useState, useEffect } from 'react';
import { TOKENS } from '../tokens';
import api from '../api/client';
import { CheckCircle2, Clock, PlayCircle, Plus } from 'lucide-react';

export function TasksScreen() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    try {
      // For now we fetch standard tasks; in a fuller implementation, this would fetch pm_tasks or tasks with project_id
      const { data } = await api.get('/tasks');
      // filter to only those that have a project_id (if your backend returns it) or just show all for now
      setTasks(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontFamily: 'Fraunces', color: TOKENS.navyDeep }}>Project Tasks</h2>
        <button style={{
          background: TOKENS.navyDeep, color: '#fff', 
          border: 'none', padding: '10px 16px', borderRadius: 8, 
          fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer'
        }}>
          <Plus size={18} /> Assign Task
        </button>
      </div>

      {loading ? (
        <p>Loading tasks...</p>
      ) : tasks.length === 0 ? (
        <div style={{ background: '#fff', padding: 40, borderRadius: 16, textAlign: 'center', color: '#666' }}>
          <CheckCircle2 size={48} style={{ opacity: 0.2, marginBottom: 16 }} />
          <h3>No tasks found</h3>
          <p>Assign tasks to your team members for project delivery.</p>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa', borderBottom: '1px solid #eee', textAlign: 'left', color: '#666', fontSize: 13 }}>
                <th style={{ padding: '16px 20px' }}>Task Title</th>
                <th style={{ padding: '16px 20px' }}>Assignee</th>
                <th style={{ padding: '16px 20px' }}>Status</th>
                <th style={{ padding: '16px 20px' }}>Due Date</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map(t => (
                <tr key={t.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '16px 20px', fontWeight: 500, color: TOKENS.navyDeep }}>{t.title}</td>
                  <td style={{ padding: '16px 20px', color: '#555' }}>{t.employee_id}</td>
                  <td style={{ padding: '16px 20px' }}>
                    <span style={{ 
                      background: t.status === 'completed' ? '#E6F4EA' : '#F3F4F6',
                      color: t.status === 'completed' ? '#1E8E3E' : '#4B5563',
                      padding: '4px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4
                    }}>
                      {t.status === 'completed' ? <CheckCircle2 size={14} /> : <Clock size={14} />}
                      {t.status}
                    </span>
                  </td>
                  <td style={{ padding: '16px 20px', color: '#888', fontSize: 14 }}>
                    {t.due_date || t.time || 'No date'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
